import { MetadataScopesPayload } from '@/types/metadata';

/** Unfiltered scopes for the logged-in user — used for nav gating only. Never pass leaderId. */
export const VIEWER_OWN_METADATA_SCOPES_QUERY_ARG = {} satisfies MetadataScopesPayload;
